var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#yester';
                    var viewUrl = 'svg/icons.svg#view-yester';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 464 464',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };